import { translate } from '@ngneat/transloco';
import { Component, Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProgressLoaderComponent } from '../components/common/progress-loader/progress-loader.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './language.service';
import { languages } from '../constants/languages';

@Injectable({
  providedIn: 'root'
})
export class ProgressLoaderService {
  private dialogRef: DynamicDialogRef | null = null;

  constructor(private dialogService: DialogService,private translate: TranslateService) { }

  show(title: string = this.translate.instant('Loading')) {
    this.dialogRef = this.dialogService.open(ProgressLoaderComponent, {
      width: '300px',
      closable: false,
      closeOnEscape: false,
      dismissableMask: false,
      showHeader: false,
      styleClass: 'progress-loader-dialog',
      data: { title: title }
    });
  }

  hide() {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
